<template>
  <div>
  <select v-show="type == 'status' || type == 'sort'" v-model="activeValue" class="status--filter" @change="onTabChange()">
    <option v-for="(value, status) in items" :key="status" :value="status">
      {{ $t(`${pathPrefix}.${status}.TEXT`) }}
    </option>
  </select>
  <select v-show="type == 'classification'" v-model="activeValue" class="status--filter" @change="onTabChange()">
    <option key="all" value="all">
      {{ $t(`CHAT_LIST.CHAT_STATUS_FILTER_ITEMS.all.TEXT`) }}
    </option>
    <option v-for="(value) in classificationItems" :key="value" :value="value">
      {{ value }}
    </option>
  </select>

  <select v-show="type == 'read_status'" v-model="activeValue" class="status--filter" @change="onTabChange()">
  <option v-for="item in items" :key="item.key" :value="item.key">
    {{ item.label }}
  </option>
</select>
</div>
</template>
<script>
export default {
  props: {
    selectedValue: {
      type: String,
      required: true,
    },
    items: {
      type: Object,
      required: false,
    },
    classificationItems: {
      type: Array,
      required: false,
    },
    type: {
      type: String,
      required: true,
    },
    pathPrefix: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      activeValue: this.selectedValue,
    };
  },
  methods: {
    onTabChange() {
      if (this.type === 'status') {
        this.$store.dispatch('setChatStatusFilter', this.activeValue);
      } else if (this.type === 'sort') {
        this.$store.dispatch('setChatSortFilter', this.activeValue);
      } else if (this.type === 'read_status') {
        this.$store.dispatch('changeReadStatusFilter', this.activeValue);
      } else {
        this.$store.dispatch('setChatClassificationFilter', this.activeValue);
      }
      this.$emit('onChangeFilter', this.activeValue, this.type);
    },
  },
};
</script>
<style lang="scss" scoped>
.status--filter {
  background-color: var(--color-background-light);
  border: 1px solid var(--color-border);
  font-size: var(--font-size-mini);
  height: var(--space-medium);
  margin: 0 var(--space-smaller);
  padding: 0 var(--space-medium) 0 var(--space-small);
  width: 126px;
}
</style>
